<script>
  export let elements;
  export let value;
  export let lang = undefined;
</script>

<div class='small-header'>
  {#each elements as element}
    <div class='small-header-element'
      class:small-header-element-active={element.value === value}
      on:click={() => { value = element.value; }}>

      <div> {element.label[lang]} </div>
    </div>
  {/each}
</div>

<style>
  .small-header {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .small-header-element {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 20px;

    padding: 10px 20px;

    border-radius: var(--radius-lg);

    cursor: pointer;
    user-select: none;

    transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;
  }

  .small-header-element:not(.small-header-element-active):hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .small-header-element-active {
    background: var(--black);
    color: var(--white);
  }

  :global(body.dark) .small-header-element:not(.small-header-element-active):hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  :global(body.dark) .small-header-element-active {
    background: var(--grey-3);
    color: var(--grey-9);
  }

  @media only screen and (max-width: 600px) {
    .small-header-element {
      flex-grow: 1;

      width: calc((100% - 90px) / 2);
    }

    .small-header-element:first-child {
      width: 100%;
    }
  }
</style>
